"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClockViewSoild = exports.TimePickerViewSoild = exports.CalendarSoild = exports.KeyboardDateTimePickerSoild = exports.DateTimePickerSoild = exports.KeyboardTimePickerSolid = exports.TimePickerSolid = exports.KeyboardDatePickerSoild = exports.DatePickerSoild = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var date_fns_1 = tslib_1.__importDefault(require("@date-io/date-fns"));
var pickers_1 = require("@material-ui/pickers");
function DatePickerSoild(props) {
    return (React.createElement("div", null,
        React.createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1.default },
            React.createElement(pickers_1.DatePicker, tslib_1.__assign({}, props)))));
}
exports.DatePickerSoild = DatePickerSoild;
function KeyboardDatePickerSoild(props) {
    return (React.createElement("div", null,
        React.createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1.default },
            React.createElement(pickers_1.KeyboardDatePicker, tslib_1.__assign({}, props)))));
}
exports.KeyboardDatePickerSoild = KeyboardDatePickerSoild;
function TimePickerSolid(props) {
    return (React.createElement("div", null,
        React.createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1.default },
            React.createElement(pickers_1.TimePicker, tslib_1.__assign({}, props)))));
}
exports.TimePickerSolid = TimePickerSolid;
function KeyboardTimePickerSolid(props) {
    return (React.createElement("div", null,
        React.createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1.default },
            React.createElement(pickers_1.KeyboardTimePicker, tslib_1.__assign({}, props)))));
}
exports.KeyboardTimePickerSolid = KeyboardTimePickerSolid;
function DateTimePickerSoild(props) {
    return (React.createElement("div", null,
        React.createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1.default },
            React.createElement(pickers_1.DateTimePicker, tslib_1.__assign({}, props)))));
}
exports.DateTimePickerSoild = DateTimePickerSoild;
function KeyboardDateTimePickerSoild(props) {
    return (React.createElement("div", null,
        React.createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1.default },
            React.createElement(pickers_1.KeyboardDateTimePicker, tslib_1.__assign({}, props)))));
}
exports.KeyboardDateTimePickerSoild = KeyboardDateTimePickerSoild;
function CalendarSoild(props) {
    return (React.createElement("div", null,
        React.createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1.default },
            React.createElement(pickers_1.Calendar, tslib_1.__assign({}, props)))));
}
exports.CalendarSoild = CalendarSoild;
function TimePickerViewSoild(props) {
    return (React.createElement("div", null,
        React.createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1.default },
            React.createElement(pickers_1.TimePickerView, tslib_1.__assign({}, props)))));
}
exports.TimePickerViewSoild = TimePickerViewSoild;
function ClockViewSoild(props) {
    return (React.createElement("div", null,
        React.createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1.default },
            React.createElement(pickers_1.ClockView, tslib_1.__assign({}, props)))));
}
exports.ClockViewSoild = ClockViewSoild;
//# sourceMappingURL=index.js.map